var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBasket = function SvgBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.846 0A.84.84 0 0 0 0 .833c0 .46.379.834.846.834h2.638l1.332 10.458.006.029c.116.575.434 1.092.898 1.46a2.562 2.562 0 0 0 1.63.552h9.056c.592.01 1.17-.186 1.631-.552.464-.368.782-.885.898-1.46l.005-.027L20 4.167H5.507L4.977 0H.846Zm5.64 11.853-.766-6.02h12.352l-.802 6.018a.831.831 0 0 1-.294.465.854.854 0 0 1-.547.184H7.327a.854.854 0 0 1-.546-.184.832.832 0 0 1-.294-.463Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.922 18.334a1.68 1.68 0 0 1 1.692-1.667c.934 0 1.692.746 1.692 1.666 0 .92-.758 1.667-1.692 1.667-.935 0-1.692-.746-1.692-1.666Zm8.46 0c0-.921.758-1.667 1.692-1.667.935 0 1.692.746 1.692 1.666A1.68 1.68 0 0 1 16.074 20c-.934 0-1.692-.746-1.692-1.666Z"
  })));
};
export default SvgBasket;